import { session } from "../../../utils/session";

export default {
  // The reactive session object rather than a copy of it, so that every computed
  // built on it re-runs when the signed-in user changes.
  user: () => {
    return session;
  },
};
